const CANONICAL_HOST = "lightly.web.app";
const CANONICAL_ORIGIN = `https://${CANONICAL_HOST}`;
const LEGACY_CUSTOM_HOST = ["lightly", "app"].join(".");
const LEGACY_WWW_CUSTOM_HOST = `www.${LEGACY_CUSTOM_HOST}`;

function cleanPath(path = "") {
  return String(path || "").replace(/^\/+/, "").replace(/\/+$/, "");
}

function cleanOrigin(value = "") {
  return String(value || "").trim().replace(/\/+$/, "");
}

export const BASE_URL =
  cleanOrigin(process.env.REACT_APP_PUBLIC_BASE_URL) ||
  (typeof window !== "undefined" && window.location?.origin
    ? cleanOrigin(window.location.origin)
    : CANONICAL_ORIGIN);

export const CANONICAL_BASE_URL = CANONICAL_ORIGIN;

export function buildPublicUrl(path = "") {
  const nextPath = cleanPath(path);
  return `${BASE_URL}${nextPath ? `/${nextPath}` : ""}`.replace(/\/+$/, "");
}

export function buildCanonicalPublicUrl(path = "") {
  const nextPath = cleanPath(path);
  return `${CANONICAL_BASE_URL}${nextPath ? `/${nextPath}` : ""}`.replace(/\/+$/, "");
}

export function normalizePublicUrl(url = "") {
  const value = String(url || "");
  if (!value) return value;

  const customOrigin = `https://${LEGACY_CUSTOM_HOST}`;
  const wwwCustomOrigin = `https://${LEGACY_WWW_CUSTOM_HOST}`;
  return value
    .replaceAll(wwwCustomOrigin, CANONICAL_BASE_URL)
    .replaceAll(customOrigin, CANONICAL_BASE_URL);
}

export function normalizePublicDataUrls(value) {
  if (typeof value === "string") return normalizePublicUrl(value);
  if (Array.isArray(value)) return value.map((item) => normalizePublicDataUrls(item));
  if (!value || typeof value !== "object") return value;

  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key, normalizePublicDataUrls(item)])
  );
}

export function redirectCustomDomainToCanonical(locationLike = window.location) {
  const hostname = String(locationLike?.hostname || "").toLowerCase();
  if (hostname !== LEGACY_CUSTOM_HOST && hostname !== LEGACY_WWW_CUSTOM_HOST) {
    return false;
  }

  const href = String(locationLike?.href || "");
  const target = normalizePublicUrl(href) || CANONICAL_BASE_URL;
  window.location.replace(target);
  return true;
}
